export enum BANNERS_STORAGE_KEYS {
  SMALL_PLAN_BANNER_DISMISS_KEY = 'dismissedSMALLPlanBanner',
  TRIAL_BANNER_DISMISS_KEY = 'dismissedTrialBanner',
  UPGRADE_YEARLY_DISMISS_KEY = 'dismissedUpgradeYearlyBanner',
  DOWNGRADE_BANNER_DISMISS_KEY = 'dismissedDowngradeBanner',
  PRO_PLAN_DISCOUNT_BANNER_DISMISS_KEY = 'dimissedPROPlanDiscountBanner',
  INTERVAT_INTEGRATION_BANNER_DISMISS_KEY = 'dismissedIntervatIntegrationBanner',
  GROW_DISCOUNT_BANNER_DISMISS_KEY = 'dismissedGrowDiscountBanner',
  GERMAN_PRO_PLAN_DISCOUNT_BANNER_DISMISS_KEY = 'dimissedGermanPROPlanDiscountBanner',
  BELGIUM_PEPPOL_VERIFICATION_DISMISS_KEY = 'dismissedBelgiumPeppolVerificationBanner',
}
